import { type IconSets } from "@toruslabs/vue-components";
import PortfolioIcons from "@web3auth/portfolio/icons";
import SwapIcons from "@web3auth/swap/icons";
import WalletConnectIcons from "@web3auth/walletconnect/icons";

export default {
  ...PortfolioIcons,
  ...WalletConnectIcons,
  ...SwapIcons,
  ArrowLeftIcon: () => import("@toruslabs/vue-icons/arrows/ArrowLeftIcon"),
  ArrowUpIcon: () => import("@toruslabs/vue-icons/arrows/ArrowUpIcon"),
  ChevronDownSolidIcon: () => import("@toruslabs/vue-icons/arrows/ChevronDownSolidIcon"),
  ChevronRightIcon: () => import("@toruslabs/vue-icons/arrows/ChevronRightIcon"),
  ChevronUpSolidIcon: () => import("@toruslabs/vue-icons/arrows/ChevronUpSolidIcon"),
  ClockIcon: () => import("@toruslabs/vue-icons/gadgets/ClockIcon"),
  XCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/XCircleSolidIcon"),
  CheckCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/CheckCircleSolidIcon"),
  InformationCircleSolidIcon: () => import("@toruslabs/vue-icons/security/InformationCircleSolidIcon"),
  MenuAltTwoSolidIcon: () => import("@toruslabs/vue-icons/menu/MenuAltTwoSolidIcon"),
  DocumentDuplicateIcon: () => import("@toruslabs/vue-icons/file/DocumentDuplicateIcon"),
  XSolidIcon: () => import("@toruslabs/vue-icons/notifications/XSolidIcon"),
  HomeSolidIcon: () => import("@toruslabs/vue-icons/maps/HomeSolidIcon"),
  SwitchVerticalIcon: () => import("@toruslabs/vue-icons/arrows/SwitchVerticalIcon"),
  SwitchHorizontalIcon: () => import("@toruslabs/vue-icons/arrows/SwitchHorizontalIcon"),
  CogIcon: () => import("@toruslabs/vue-icons/others/CogIcon"),
  PencilSolidIcon: () => import("@toruslabs/vue-icons/mail/PencilSolidIcon"),
  ExternalLinkIcon: () => import("@toruslabs/vue-icons/mail/ExternalLinkIcon"),
  DownloadIcon: () => import("@toruslabs/vue-icons/software/DownloadIcon"),
  GoogleIcon: () => import("@toruslabs/vue-icons/auth/GoogleIcon"),
  QrcodeIcon: () => import("@toruslabs/vue-icons/software/QrcodeIcon"),
  PlusIcon: () => import("@toruslabs/vue-icons/notifications/PlusIcon"),
  LogoutIcon: () => import("@toruslabs/vue-icons/notifications/LogoutIcon"),
  LoginIcon: () => import("@toruslabs/vue-icons/notifications/LoginIcon"),
  WalletConnectIcon: () => import("./WalletConnectIcon.vue"),
  WalletIcon: () => import("./WalletIcon.vue"),
  WindowBlock: () => import("./WindowBlock.vue"),
  SmartAccountIcon: () => import("./SmartAccountIcon.vue"),
  ExpandIcon: () => import("./ExpandIcon.vue"),
  CollapseIcon: () => import("./CollapseIcon.vue"),
  FacebookIcon: () => import("@toruslabs/vue-icons/auth/FacebookIcon"),
  WifiSolidIcon: () => import("@toruslabs/vue-icons/connection/WifiSolidIcon"),
  GlobeAltSolidIcon: () => import("@toruslabs/vue-icons/maps/GlobeAltSolidIcon"),
} as unknown as IconSets;
